var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesnpermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.4252H3.45C3.397 20.4252 3.346 20.4032 3.309 20.3662C3.271 20.3282 3.25 20.2782 3.25 20.2252V18.7742C3.25 17.9442 3.843 17.2122 4.757 16.5902C6.389 15.4762 9.03 14.7742 12 14.7742C12.414 14.7742 12.75 14.4382 12.75 14.0242C12.75 13.6112 12.414 13.2742 12 13.2742C8.678 13.2742 5.737 14.1052 3.911 15.3502C2.518 16.3002 1.75 17.5072 1.75 18.7742V20.2252C1.75 20.6752 1.929 21.1082 2.248 21.4272C2.567 21.7452 2.999 21.9252 3.45 21.9252H12C12.414 21.9242 12.75 21.5882 12.75 21.1742C12.75 20.7612 12.414 20.4242 12 20.4252Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.41211C8.964 1.41211 6.5 3.87611 6.5 6.91211C6.5 9.94811 8.964 12.4121 12 12.4121C15.036 12.4121 17.5 9.94811 17.5 6.91211C17.5 3.87611 15.036 1.41211 12 1.41211ZM12 2.91211C14.208 2.91211 16 4.70411 16 6.91211C16 9.12011 14.208 10.9121 12 10.9121C9.792 10.9121 8 9.12011 8 6.91211C8 4.70411 9.792 2.91211 12 2.91211Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9995 14.1001C16.0335 14.1001 14.4375 15.6961 14.4375 17.6621C14.4375 19.6281 16.0335 21.2251 17.9995 21.2251C19.9655 21.2251 21.5625 19.6281 21.5625 17.6621C21.5625 15.6961 19.9655 14.1001 17.9995 14.1001ZM17.9995 15.6001C19.1375 15.6001 20.0625 16.5241 20.0625 17.6621C20.0625 18.8001 19.1375 19.7251 17.9995 19.7251C16.8615 19.7251 15.9365 18.8001 15.9365 17.6621C15.9365 16.5241 16.8615 15.6001 17.9995 15.6001Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 14.8491V13.1621C18.75 12.7481 18.414 12.4121 18 12.4121C17.586 12.4121 17.25 12.7481 17.25 13.1621V14.8501C17.25 15.2631 17.586 15.6001 18 15.6001C18.414 15.5991 18.75 15.2631 18.75 14.8491Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5222 16.2042L21.7152 15.0102C22.0082 14.7182 22.0082 14.2422 21.7152 13.9502C21.4232 13.6572 20.9472 13.6572 20.6552 13.9502L19.4612 15.1432C19.1692 15.4362 19.1692 15.9112 19.4612 16.2042C19.7542 16.4962 20.2292 16.4962 20.5222 16.2042Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8115 18.4121H22.4995C22.9135 18.4121 23.2495 18.0761 23.2495 17.6621C23.2495 17.2481 22.9135 16.9121 22.4995 16.9121H20.8115C20.3985 16.9121 20.0625 17.2481 20.0625 17.6621C20.0615 18.0761 20.3985 18.4121 20.8115 18.4121Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4612 20.1811L20.6552 21.3741C20.9472 21.6671 21.4232 21.6671 21.7152 21.3741C22.0082 21.0821 22.0082 20.6061 21.7152 20.3141L20.5222 19.1201C20.2292 18.8281 19.7542 18.8281 19.4612 19.1201C19.1692 19.4131 19.1692 19.8881 19.4612 20.1811Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 20.4741V22.1621C17.25 22.5761 17.586 22.9121 18 22.9121C18.414 22.9121 18.75 22.5761 18.75 22.1621V20.4741C18.75 20.0611 18.414 19.7251 18 19.7241C17.586 19.7241 17.25 20.0611 17.25 20.4741Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4831 19.1201L14.2901 20.3141C13.9971 20.6061 13.9971 21.0821 14.2901 21.3741C14.5821 21.6671 15.0581 21.6671 15.3501 21.3741L16.5441 20.1811C16.8361 19.8881 16.8361 19.4131 16.5441 19.1201C16.2511 18.8281 15.7761 18.8281 15.4831 19.1201Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.187 16.9121H13.5C13.086 16.9121 12.75 17.2481 12.75 17.6621C12.75 18.0761 13.086 18.4121 13.5 18.4121H15.187C15.601 18.4121 15.938 18.0761 15.937 17.6621C15.937 17.2481 15.601 16.9121 15.187 16.9121Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5441 15.1432L15.3501 13.9502C15.0581 13.6572 14.5821 13.6572 14.2901 13.9502C13.9971 14.2422 13.9971 14.7182 14.2901 15.0102L15.4831 16.2042C15.7761 16.4962 16.2511 16.4962 16.5441 16.2042C16.8361 15.9112 16.8361 15.4362 16.5441 15.1432Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesnpermission);
export default __webpack_public_path__ + "static/media/rolesnpermission.47f85f4defc05a13f8c1c112ff3623e6.svg";
export { ForwardRef as ReactComponent };